import type { RootState } from '@core/core/store'
import { createSelector } from '@reduxjs/toolkit'

import { contextMenuCollectionAdapter } from './contextMenuCollectionSlice'

const { selectById } = contextMenuCollectionAdapter.getSelectors<RootState>(
  state => state.contextMenu,
)

export const selectContextMenuItemsByType = createSelector([selectById], menu => menu?.items ?? [])
